import { StyleSheet } from "@react-pdf/renderer";
/* jscpd:ignore-start */
export const styles = StyleSheet.create({
  // GENERAL
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  // TOP
  header: {
    fontSize: 12,
    marginBottom: 10,
    fontFamily: "Proxima Nova Bold",
    flexDirection: "row",
  },
  // TITLE
  headerTitleCol: {
    width: "60%",
  },
  title: {
    // marginTop: 32,
    fontSize: 32,
    fontFamily: "Proxima Nova Bold",
  },
  // LOGO
  logoCol: {
    width: "10%",
    // transform: "scale(0.4)",
  },
  logo: {
    width: "25%",
    // marginTop: 48,
    // marginRight: -10,
    // transform: "rotate(-90deg)",
    // backgroundColor: "black",
  },
  // IMAGE
  headerImgCol: {
    width: "30%",
  },
  image: {
    marginVertical: 0,
    marginHorizontal: 0,
  },
  // REZEPT
  mainView: {
    flexDirection: "row",
    marginBottom: 20,
  },
  recipeHeader: {
    marginTop: 48,
    marginBottom: 6,
  },
  recipeTitle: {
    marginBottom: 0,
    fontSize: 20,
    fontFamily: "Proxima Nova Bold",
  },
  portion: {
    fontSize: 16,
    marginBottom: 8,
    fontFamily: "Proxima Nova Regular",
  },
  recipeView: {
    width: "60%",
    flexDirection: "column",
  },
  recipeLine: {
    flexDirection: "row",
  },
  notizenView: {
    width: "40%",
    // marginTop: -28,
  },
  checkbox: {
    width: "12px",
    height: "12px",
    border: "1px solid black",
    borderRadius: 4,
    marginRight: 6,
  },
  amountCol: {
    marginRight: 6,
    fontSize: 12,
    fontFamily: "Proxima Nova Regular",
    flexDirection: "row",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  // NOTIZEN
  notizenTitle: {
    color: "#e62a2b",
    fontFamily: "Proxima Nova Bold",
  },
  notizenLines: {
    borderBottom: "1px solid black",
    marginTop: 24,
  },
  // HINWEIS
  noticeView: {
    marginTop: 6,
    backgroundColor: "#FEF4CF",
    padding: 12,
    flexDirection: "row",
  },
  infoImage: {
    width: "12px",
    height: "12px",
    marginLeft: "-6px",
    marginRight: "6px",
  },
  notice: {
    fontSize: 12,
    marginRight: "6px",
    lineHeight: 1.5,
  },
  noticeStrong: {
    color: "red",
    fontWeight: 700,
    fontSize: 12,
    lineHeight: 1.5,
  },
  // TIPP
  tippView: {
    marginTop: "auto",
    marginBottom: "12px",
    flexDirection: "column",
  },
  tippLine: {
    flexDirection: "row",
  },
  redDot: {
    marginTop: 4,
    width: "6px",
    height: "6px",
    border: "1px solid #e62a2b",
    backgroundColor: "#e62a2b",
    // borderRadius: "50%",
    marginRight: 6,
  },
  tippLabel: {
    color: "#e62a2b",
    fontSize: 12,
    marginTop: 20,
    marginBottom: 10,
    fontFamily: "Proxima Nova Bold",
  },
  rezeptTipp: {
    fontSize: 12,
    marginRight: 12,
    fontFamily: "Proxima Nova Regular",
  },
});
/* jscpd:ignore-end */
